import React from 'react';
const paymentMethods = [{
  name: 'Mercado Pago',
  logo: 'https://cdn.magicpatterns.com/uploads/hqx7aboqoVKsxs671U5Da9/MP_RGB_HANDSHAKE_color_horizontal.svg',
  wide: true,
  extraWide: true
}, {
  name: 'Visa',
  logo: 'https://cdn.magicpatterns.com/uploads/bkUXwUvyxby3GhX68Dztgf/visa-brandmark-blue-1960x622.webp',
  wide: true
}, {
  name: 'Mastercard',
  logo: 'https://cdn.magicpatterns.com/uploads/1yfpiKUKAyAQLtsBiocrm6/ma_symbol.svg',
  wide: false
}, {
  name: 'American Express',
  logo: 'https://cdn.magicpatterns.com/uploads/tZq6zJarvpaADNnYzWvaQV/30_material.png',
  wide: false
}];
interface PaymentLogosProps {
  className?: string;
}
export function PaymentLogos({
  className = ''
}: PaymentLogosProps) {
  return <div className={`flex items-center gap-4 ${className}`} data-id="element-326">
      {paymentMethods.map(method => <img key={method.name} src={method.logo} alt={method.name} className={`object-contain ${(method as any).extraWide ? 'h-10 w-32' : method.wide ? 'h-6 w-16' : 'h-8 w-8'}`} data-id="element-327" />)}
    </div>;
}